//  customer-reviews-slider.js

(function () {
    'use strict';

    function initSlider(sliderId) {
      var slider=document.querySelector('[data-slider="' + sliderId + '"]');
      if ( !slider) return;

      var cards=Array.prototype.slice.call(slider.querySelectorAll('.reviews-section__card'));
      var totalCards=cards.length;
      if (totalCards===0) return;

      var currentIdx=0;
      var gap=parseInt(slider.dataset.cardGap, 10) || 16;
      var fixedWidth=parseInt(slider.dataset.cardWidth, 10) || 438;


      function isMobile() {
        return window.innerWidth < 768;
      }

      function getCardWidth() {
        if (isMobile()) {
          return slider.parentElement.offsetWidth;
        }

        return fixedWidth;
      }

      function getMaxIdx() {
        var wrapWidth=slider.parentElement.offsetWidth;
        var cardW=getCardWidth();
        var visible=Math.max(1, Math.floor((wrapWidth + gap) / (cardW + gap)));
        return Math.max(0, totalCards - visible);
      }

      function recalc() {
        var cardW=getCardWidth();

        cards.forEach(function (card) {
            card.style.minWidth=cardW + 'px';
            card.style.maxWidth=cardW + 'px';
          });
        slider.style.gap=gap + 'px';
        currentIdx=Math.min(currentIdx, getMaxIdx());
        go(currentIdx, false);
      }

      function go(idx, animate) {
        var cardW=getCardWidth();
        var offset=idx * (cardW + gap);
        slider.style.transition=animate ? 'transform 0.42s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
        slider.style.transform='translateX(-' + offset + 'px)';
      }

      document.querySelectorAll('[data-slider-prev="' + sliderId + '"]').forEach(function (btn) {
          btn.addEventListener('click', function () {
              currentIdx=currentIdx > 0 ? currentIdx - 1 : getMaxIdx();
              go(currentIdx, true);
            });
        });

      document.querySelectorAll('[data-slider-next="' + sliderId + '"]').forEach(function (btn) {
          btn.addEventListener('click', function () {
              currentIdx=currentIdx < getMaxIdx() ? currentIdx + 1 : 0;
              go(currentIdx, true);
            });
        });


      var touchStartX=0;

      slider.addEventListener('touchstart', function (e) {
          touchStartX=e.changedTouches[0].screenX;
        }

        , {
        passive: true
      });

    slider.addEventListener('touchend', function (e) {
        var diff=touchStartX - e.changedTouches[0].screenX;

        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            currentIdx=currentIdx < getMaxIdx() ? currentIdx + 1 : 0;
          }

          else {
            currentIdx=currentIdx > 0 ? currentIdx - 1 : getMaxIdx();
          }

          go(currentIdx, true);
        }
      }

      , {
      passive: true
    });


  var resizeTimer;

  window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer=setTimeout(recalc, 150);
    });
  recalc();
}

document.querySelectorAll('[data-slider]').forEach(function (el) {
    initSlider(el.dataset.slider);
  });

})();